import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MaReturnToMainSiteLinkClasses,
} from '@dxp-module/themes'

const returnToMainSiteLinkStyles = makeStyles<
  MyAccountTheme,
  object,
  MaReturnToMainSiteLinkClasses
>(
  () => ({
    linkText: {
      margin: '5px 0',
    },
    linkIcon: {},
    container: {
      display: 'flex',
      alignItems: 'center',
    },
  }),
  { name: 'MyAccount_ReturnToMainSiteLink' }
)

export default returnToMainSiteLinkStyles
